// This is a HOC that is used to toggle the comments on and off hook - the hook logic is in useToggleCommentMode.js

import React from "react";
import { useCommentStore } from "../stores/commentStore";
import { useProjectStore } from "../stores/projectStore";
import { toggleCommentsLogic } from "./useToggleCommentMode";

export const withCommentToggle = (WrappedComponent) => {
  return class WithCommentToggle extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        showComments: useCommentStore.getState().showComments,
      };
    }

    componentDidMount() {
      // Subscribe to store changes
      this.unsubscribe = useCommentStore.subscribe((state) => {
        this.setState({ showComments: state.showComments });
      });
    }

    componentWillUnmount() {
      // Cleanup subscription
      if (this.unsubscribe) {
        this.unsubscribe();
      }
    }

    toggleComments = (newShowCommentState) => {
      const stores = {
        setShowComments: useCommentStore.getState().setShowComments,
        columnWidths: useProjectStore.getState().columnWidths,
        setRightBarCollapsed: useProjectStore.getState().setRightBarCollapsed,
        setLeftBarCollapsed: useProjectStore.getState().setLeftBarCollapsed,
        setColumnWidths: useProjectStore.getState().setColumnWidths,
      };

      toggleCommentsLogic(newShowCommentState, stores);
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          showComments={this.state.showComments}
          toggleComments={this.toggleComments}
        />
      );
    }
  };
};
